import { render } from "./TelegramChats.vue?vue&type=template&id=546856db&scoped=true"
import script from "./TelegramChats.vue?vue&type=script&lang=js"
export * from "./TelegramChats.vue?vue&type=script&lang=js"

import "./TelegramChats.vue?vue&type=style&index=0&id=546856db&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-546856db"]])

export default __exports__